import i18next from "i18next"

/*****************************
 ***** Bike notifications ****
*****************************/
export const NOTIFICATION_PURCHASE_VALIDATION = "PURCHASE_VALIDATION"
const NOTIFICATION_PURCHASE_VALIDATION_VALUE = 1

export const NOTIFICATION_NEW_PROPERTY_VALIDATION = "NEW_PROPERTY_VALIDATION"
const NOTIFICATION_NEW_PROPERTY_VALIDATION_VALUE = 2

export const NOTIFICATION_BIKE_RETURN_VALIDATION = "BIKE_RETURN_VALIDATION"
const NOTIFICATION_BIKE_RETURN_VALUE = 3

export const NOTIFICATION_BIKE_BUYBACK_VALIDATION = "BIKE_BUYBACK_VALIDATION"
const NOTIFICATION_BIKE_BUYBACK_VALUE = 4

type modalBikesNotificationsProps = {
	title: string
	acceptedDescription: string
	refusedDescription: string
	acceptedButtonLabel: string
	refusedButtonLabel: string
}

export const bikesNotifications: Array<{
id: string
value: number
title: string
modal: modalBikesNotificationsProps
}> = [
	{
		id: NOTIFICATION_PURCHASE_VALIDATION,
		value: NOTIFICATION_PURCHASE_VALIDATION_VALUE,
		title: i18next.t("notification.new_bike", { ns: "bike" }),
		modal: {
			title: i18next.t("notification.new_bike_modal_title", { ns: "bike" }),
			acceptedDescription: i18next.t("notification.new_bike_modal_accepted_description", { ns: "bike" }),
			refusedDescription: i18next.t("notification.new_bike_modal_refused_description", { ns: "bike" }),
			acceptedButtonLabel: i18next.t("notification.new_bike_modal_accepted_button", { ns: "bike" }),
			refusedButtonLabel: i18next.t("notification.new_bike_modal_refused_button", { ns: "bike" }),
		}
	},
	{
		id: NOTIFICATION_NEW_PROPERTY_VALIDATION,
		value: NOTIFICATION_NEW_PROPERTY_VALIDATION_VALUE,
		title: i18next.t("notification.new_bike", { ns: "bike" }),
		modal: {
			title: i18next.t("notification.new_bike_modal_title", { ns: "bike" }),
			acceptedDescription: i18next.t("notification.new_bike_modal_accepted_description", { ns: "bike" }),
			refusedDescription: i18next.t("notification.new_bike_modal_refused_description", { ns: "bike" }),
			acceptedButtonLabel: i18next.t("notification.new_bike_modal_accepted_button", { ns: "bike" }),
			refusedButtonLabel: i18next.t("notification.new_bike_modal_refused_button", { ns: "bike" }),
		}
	},
	{
		id: NOTIFICATION_BIKE_RETURN_VALIDATION,
		value: NOTIFICATION_BIKE_RETURN_VALUE,
		title: i18next.t("notification.back_store_modal_title", { ns: "bike" }),
		modal: {
			title: i18next.t("notification.back_store_modal_title", { ns: "bike" }),
			acceptedDescription: i18next.t("notification.back_store_modal_accepted_description", { ns: "bike" }),
			refusedDescription: i18next.t("notification.back_store_modal_refused_description", { ns: "bike" }),
			acceptedButtonLabel: i18next.t("notification.back_store_modal_accepted_button", { ns: "bike" }),
			refusedButtonLabel: i18next.t("notification.back_store_modal_refused_button", { ns: "bike" }),
		}
	},
	{
		id: NOTIFICATION_BIKE_BUYBACK_VALIDATION,
		value: NOTIFICATION_BIKE_BUYBACK_VALUE,
		title: i18next.t("notification.buy_bike_modal_title", { ns: "bike" }),
		modal: {
			title: i18next.t("notification.buy_bike_modal_title", { ns: "bike" }),
			acceptedDescription: i18next.t("notification.buy_bike_modal_accepted_description", { ns: "bike" }),
			refusedDescription: i18next.t("notification.buy_bike_modal_refused_description", { ns: "bike" }),
			acceptedButtonLabel: i18next.t("notification.back_store_modal_accepted_button", { ns: "bike" }),
			refusedButtonLabel: i18next.t("notification.back_store_modal_refused_button", { ns: "bike" }),
		}
	},
]